import { create } from 'zustand';

interface AppStoreState {
	config: Object;
	serverUrl?: string | null;
	inDevelopment?: boolean;
	sessionId?: string | null;
	urlPath: string;
	isPreview: boolean;
	isFocused?: boolean;

	analyticsEnabled?: boolean;

	visibleGroups?: string[];

	setConfig: (config: Object) => void;
	setSessionId: (sessionId: string | null) => void;
	setAnalyticsEnabled: (enabled: boolean) => void;
	addVisibleGroup: (group: string) => void;
	removeVisibleGroup: (group: string) => void;
	setUrlPath: (path: string) => void;
	setIsPreview: (isPreview: boolean) => void;
	setIsFocused?: (isFocused: boolean) => void;
}

const useAppStore = create<AppStoreState>((set) => ({
	config: {},
	inDevelopment: !process.env.NODE_ENV || process.env.NODE_ENV === 'development',
	serverUrl: null, // Default server URL
	sessionId: null, // Default session ID
	analyticsEnabled: false, // Default analytics enabled state
	visibleGroups: [], // Default visible groups
	urlPath: '', // Default URL path
	isPreview: false, // Default preview state
	isFocused: true, // Default focus state

	// Functions
	setConfig: (config) => {
		set({
			config,
			serverUrl: config?.serverUrl || null, // Default server URL if not provided
		});
	},
	setSessionId: (sessionId) => set({ sessionId }),
	setAnalyticsEnabled: (enabled) => set({ analyticsEnabled: enabled }),
	addVisibleGroup: (group) => set((state) => {
		if (!state.visibleGroups?.includes(group)) {
			return {
				visibleGroups: [...state.visibleGroups ?? [], group]
			};
		}
	}),
	removeVisibleGroup: (group) => set((state) => {

		if (!state.visibleGroups.includes(group)) {
			return state; // No change if group is not in the list
		}
		
		return ({
			visibleGroups: state.visibleGroups.filter((g) => g !== group)
		});
	}),
	setUrlPath: (path) => set({ urlPath: path }),
	setIsPreview: (isPreview) => set({ isPreview }),
	setIsFocused: (isFocused) => set({ isFocused })
}));

export default useAppStore;
